import { ApiRoutes } from '@/shared/constant/api';
import { api } from '@/shared/helpers/axios';

import { IRestriction, RestrictionsResponseType } from '../types/restriction.types';

export const restrictionApi = {
	getRestrictions: () =>
		api.get(ApiRoutes.Restrictions).then((res) => (res.data as RestrictionsResponseType)?.objects),
	updateRestriction: ({ id, payload }: { id: number; payload: IRestriction }) =>
		api.put(`${ApiRoutes.Restrictions}/${id}`, {
			...payload,
		}),
};
